var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.screenWidth < 540)?_c('adminmenuSM'):(_vm.screenWidth < 1058)?_c('adminMenuMd'):_c('adminMenuLg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }